import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import ModalLayout from '../layouts/ModalLayout'
import { modalSecondaryButtonStyle } from '../styles/buttonStyles'

const AppFeaturesModal = ({
  open,
  onClose,
  onMouseEnter,
  onMouseLeave,
  size = 'large'
}) => {
  const { t } = useTranslation(['translation', 'features'])
  const [pressedBtn, setPressedBtn] = useState(null)
  const [hoverBtn, setHoverBtn] = useState(null)

  useEffect(() => {
    if (!open) return

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose()
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [open, onClose])

  if (!open) return null

  const features = t('features:features', {
    returnObjects: true
  })

  return (
    <ModalLayout
      open={open}
      onClose={onClose}
      size={size}
      zIndex={4000}
    >
      <h3 style={{ fontSize: 24, marginTop: 5, marginBottom: 20 }}>
        {t('features:FEATURES_PAGE_TITLE')}
      </h3>

      <Box
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        sx={{ overflowY: 'auto', flex: 1 }}
      >
        {features.map((section, i) => (
          <Box key={i} sx={{ mb: 3 }}>
            <Typography sx={{ fontWeight: 'bold', fontSize: 18, mb: 1 }}>
              {section.title}
            </Typography>

            {section.items &&
              section.items.map((item, j) => (
                <Typography key={j}>
                  • {item}
                </Typography>
              ))}

            {section.features &&
              section.features.map((sub, k) => (
                <Box key={k} sx={{ mt: 2 }}>
                  <Typography sx={{ fontWeight: 'bold' }}>
                    {sub.title}
                  </Typography>

                  {sub.items.map((subItem, m) => (
                    <Typography key={m}>
                      • {subItem}
                    </Typography>
                  ))}
                </Box>
              ))}
          </Box>
        ))}
      </Box>

      <Box
        sx={{
          borderTop: '1px solid #ddd',
          pt: 2,
          pb: 0,
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <button
          style={modalSecondaryButtonStyle(
            pressedBtn,
            'close',
            hoverBtn === 'close'
          )}
          onMouseEnter={() => setHoverBtn('close')}
          onMouseLeave={() => {
            setHoverBtn(null)
            setPressedBtn(null)
          }}
          onMouseDown={() => setPressedBtn('close')}
          onMouseUp={() => setPressedBtn(null)}
          onClick={onClose}
        >
          {t('CLOSE')}
        </button>
      </Box>
    </ModalLayout>
  )
}

export default AppFeaturesModal